// extracted by mini-css-extract-plugin
export default {"msgM":"_42f2cf4a09"};